module.exports = "/_next/static/images/location-marker-9f9f890c26ea5b32443ff94ce6c16589.png";